export default {
  rid: 12126,
  needsRedecision: false,
  predictionResults: [
    {
      riskRating: 0.130892,
      smartRate: null,
      id: 41,
      topAttrs: [
        'total_debt_to_rev',
        'business_score_max',
        'inquiries_last_six_months',
        'calc_gross_margin_for_year_CY',
        'paid_accounts_counter'
      ],
      createdAt: '2019-03-21T22:40:45+00:00',
      predictionModel: {
        dataPermutation: 'complete',
        version: '3',
        type: 'default',
        __typename: 'PredictionModel'
      },
      __typename: 'PredictionResult'
    },
    {
      riskRating: 0.130892,
      smartRate: null,
      id: 44,
      topAttrs: [
        'total_debt_to_rev',
        'business_score_max',
        'inquiries_last_six_months',
        'calc_gross_margin_for_year_CY',
        'paid_accounts_counter'
      ],
      createdAt: '2019-03-21T22:30:45+00:00',
      predictionModel: {
        dataPermutation: 'complete',
        version: '3',
        type: 'default',
        __typename: 'PredictionModel'
      },
      __typename: 'PredictionResult'
    },
    {
      riskRating: 0.130892,
      smartRate: null,
      id: 50,
      topAttrs: [
        'total_debt_to_rev',
        'business_score_max',
        'inquiries_last_six_months',
        'calc_gross_margin_for_year_CY',
        'paid_accounts_counter'
      ],
      createdAt: '2019-03-21T23:30:45+00:00',
      predictionModel: {
        dataPermutation: 'complete',
        version: '3',
        type: 'default',
        __typename: 'PredictionModel'
      },
      __typename: 'PredictionResult'
    },
    {
      riskRating: 0.105168,
      smartRate: 1,
      id: 26561,
      topAttrs: [],
      createdAt: '2019-02-22T16:08:20-08:00',
      predictionModel: {
        dataPermutation: 'credit',
        version: '2',
        type: 'cash_flow',
        __typename: 'PredictionModel'
      },
      __typename: 'PredictionResult'
    },
    {
      riskRating: null,
      smartRate: null,
      id: 26605,
      topAttrs: [],
      createdAt: '2019-03-06T12:44:02-08:00',
      predictionModel: {
        dataPermutation: 'complete',
        version: null,
        type: 'cash_flow',
        __typename: 'PredictionModel'
      },
      __typename: 'PredictionResult'
    },
    {
      riskRating: null,
      smartRate: null,
      id: 26606,
      topAttrs: [],
      createdAt: '2019-03-06T12:44:46-08:00',
      predictionModel: {
        dataPermutation: 'complete',
        version: null,
        type: 'cash_flow',
        __typename: 'PredictionModel'
      },
      __typename: 'PredictionResult'
    }
  ],
  product: {
    name: 'TAB - Conventional - 3-year',
    lenderKey: 'tab',
    finalDecision: '{"default_complete_prediction_threshold":0.1,"max_loan_to_revenue_ratio":0.25,"interim_month_cutoff":3,"num_maybe_periods":0,"decision_criteria":{"exceed_max_loan_to_revenue_ratio":true},"business_dscr":{"interim_year":{"required":"true","min_dscr":1.15},"tax_return_0":{"required":"true","min_dscr":1.15},"tax_return_1":{"required":"false"},"tax_return_2":{"required":"false"}},"global_dscr":{"interim_year":{"required":"true","min_dscr":0.8},"tax_return_0":{"required":"true","min_dscr":0.8},"tax_return_1":{"required":"false"},"tax_return_2":{"required":"false"}}}',
    __typename: 'Product'
  },
  __typename: 'Loan'
}
